import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Timeline from 'components/base/Timeline';
import { TimelineData } from 'data/timelineData';
import { orderTrackingTimelineData } from 'data/timelineData';
import { Tracking } from 'api/orders/_requests';
import { formatDate } from 'helpers/utils';

const OrderTrackingTimeline = ({ data }: { data: Tracking[] }) => {
  return (
    <Timeline variant="vertical">
      {data.map((item, index) => (
        <Timeline.Item key={item.date}>
          <div
            className={classNames('row g-md-3 align-items-center', {
              'mb-8 mb-lg-10': index !== data.length - 1
            })}
          >
            <div className="col-12 col-md-auto d-flex">
              <Timeline.OppositeContent>
                <p className="fs-10 fw-semibold text-body-tertiary mb-0 text-end">
                  {new Date(item.date).toLocaleString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </p>
              </Timeline.OppositeContent>
              <Timeline.Separator className="position-relative">
                <Timeline.Dot
                  className={
                    orderTrackingTimelineData[index].separator.dotClass
                  }
                >
                  <FontAwesomeIcon
                    icon={orderTrackingTimelineData[index].separator.icon}
                    className="text-white fs-10"
                  />
                </Timeline.Dot>
                {orderTrackingTimelineData[index].separator.barClass && (
                  <Timeline.Bar
                    style={{ height: 100 }}
                    className={
                      orderTrackingTimelineData[index].separator.barClass
                    }
                  />
                )}
              </Timeline.Separator>
            </div>
            <div className="col">
              <Timeline.Content>
                <h4>{orderTrackingTimelineData[index].content.title}</h4>
                <p className="fs-9 text-body-secondary mb-0">
                  {formatDate(item.date)}
                </p>
              </Timeline.Content>
            </div>
          </div>
        </Timeline.Item>
      ))}
    </Timeline>
  );
};

export default OrderTrackingTimeline;
